import { CSSTransition, TransitionGroup } from 'react-transition-group';
import React, { useEffect, useState } from 'react';

import { PrimaryButton, ButtonArrowState } from '@huggg/react-components';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import dictionary from 'config/dictionary';
import { interpolate } from 'utilities/interpolate';
import styles from './cookie-banner.module.scss';
import AnalyticsService from 'services/AnalyticsService';
import config from 'config';

const analytics = new AnalyticsService();

const setLocalStorage = value =>
  window.localStorage.setItem('showCookieBanner', value);

const getLocalStorage = () =>
  window.localStorage.getItem('showCookieBanner') === 'false' ? false : true;

if (!getLocalStorage()) {
  analytics.initialiseFacebookPixel(config.facebookPixelId);
}

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const CookieBanner = props => {
  const storageValue = getLocalStorage();
  const { domNode } = props;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    !inIframe() && storageValue && setVisible(true);
  }, [storageValue, setVisible]);

  const onConfirmClick = event => {
    analytics.buttonClickCookieBannerConfirm();
    analytics.initialiseFacebookPixel(config.facebookPixelId);
    setLocalStorage(false);
    setVisible(false);
  };

  return ReactDom.createPortal(
    <TransitionGroup component={null}>
      {visible ? (
        <CSSTransition
          classNames={{
            enter: styles.transitionEnter,
            enterActive: styles.transitionEnterActive,
            exit: styles.transitionExit,
            exitActive: styles.transitionExitActive
          }}
          timeout={{
            enter: 500,
            exit: 300
          }}
        >
          <div
            className={styles.cookieBanner}
            data-test-id="cookie-banner"
          >
            <div className="text">
              {interpolate(
                dictionary.cookieBanner.text,
                '[privacyLink]',
                <a
                  href="https://huggg.me/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {dictionary.cookieBanner.privacyLink}
                </a>
              )}
            </div>

            <div className={styles.actions}>
              <PrimaryButton
                type="button"
                className={styles.action}
                onClick={onConfirmClick}
                data-test-id="cookie-banner-confirm"
                label={dictionary.cookieBanner.confirmButton}
                arrow={ButtonArrowState.None}
              />
            </div>
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>,
    domNode
  );
};

CookieBanner.defaultProps = {
  domNode: document.body
};

CookieBanner.propTypes = {
  domNode: PropTypes.instanceOf(Element)
};

export default CookieBanner;
